import axios from 'axios';
import { forEach, map, isEmpty } from 'lodash';

import * as constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getApiDetails, getUserContext } from '../../reducers/api';
import { getCreateData, getUpdateData, getUpdateDetails } from './requestParser';
import { getValidationErrors } from '../../utils';

export const showLoading = (isLoading) => dispatch =>
  dispatch({
    type: constants.APP_LOADING,
    isLoading,
  });

const initApi = (dispatch, isLoading = true) =>
  dispatch({
    type: constants.APP_LOADING,
    isLoading,
  });

export const fetchAvailableUsers = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/permissions/apis/${apiUuid}/available-users`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_AVAILABLE_USER_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchSelectedUsers = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/api-management/internal/permissions/apis/${apiUuid}/selected-users`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_SELECTED_USER_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchOrganizations = (size, pageNumber) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/internal/organizations?status=ENABLED&size=${size}&page=${pageNumber}`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_ORGANIZATIONS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchAllOrganizations = (size = 1000, pageNumber = 0) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/internal/organizations?status=ENABLED&size=${size}&page=${pageNumber}`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchSelectedOrganizations = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/api-management/internal/apis/${apiUuid}/selected-organizations`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const setRedirectApiTab = () => dispatch =>
  dispatch({
    type: constants.API_PERMISSION_REDIRECT_API_TAB,
  });

export const fetchApi = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchAllTags = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tags`;

    dispatch({
      type: constants.API_TAGS_ALL_TAGS_REQUEST,
      isLoading: false,
    });
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_TAGS_ALL_TAGS_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => // todo: check errors
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchAPITags = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/tags`;
    dispatch({
      type: constants.API_TAGS_API_TAGS_REQUEST,
    });
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_TAGS_API_TAGS_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => // todo: check errors
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchSwaggerFile = (uuid: string) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/2.0/Apis('${uuid}')/SpecContent`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_SWAGGER_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => // todo: check errors
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const createTags = (data) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tags`;
    await axios.post(url, data, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_TAGS_CREATE_TAGS_SUCCESS,
          payload: response,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchApiPermitted = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/api-management/internal/permissions/apis/${apiUuid}/permitted`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_PERMITTED_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_PERMISSION_PERMITTED_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchApiEulas = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/Portal.svc/ApiEulas?$select=Uuid,Name&$inlinecount=allpages`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_EULAS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const checkApiNameUnique = (apiName, currentId) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/Portal.svc/ApiNameUnique()`;
    await axios.get(url,
      {
        params: {
          Name: `'${apiName}'`,
          CurrentId: `'${currentId}'`,
        },
      },
      {
        credentials: 'include',
      })
      .then((response) => {
        dispatch({
          type: constants.API_NAME_UNIQUE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchPolicyTemplates = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/resourceValues?resources=managedGateways,policyTemplates`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.POLICY_TEMPLATES_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const checkProxyUrlUnique = (name) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/Portal.svc/ProxyUrlUnique()?ProxyUrl='${name}'`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PROXY_URL_UNIQUE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchSelectedManageOrg = (Uuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/organizations/${Uuid}`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchCustomFields = (entityName = 'API') =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url =
      `${portal.hostname}/admin/Portal.svc/CustomFields?%24inlinecount=allpages&%24filter=EntityType+eq+%27${entityName}%27+and+Status+eq+%27ENABLED%27`;

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.CUSTOM_FIELDS_GET_SUCCESS,
          isLoading: false,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchAssets = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/assets`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_ASSETS_GET_SUCCESS,
          isLoading: false,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchUsage = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/usage`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_USAGE_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const saveAssets = async (apiDetails, uploadedAssets, portal, dispatch,
  isUploadFile, filesToDelete) => {
  const formData = new FormData();
  if (isUploadFile) {
    forEach(uploadedAssets, ({ blob, name }) => {
      if (blob) { formData.append('files', blob, name); }
    });
  }

  if (filesToDelete.length > 0) {
    forEach(filesToDelete, (uuid) => {
      formData.append('filesToDelete', uuid);
    });
  }
  const url = `${portal.hostname}/admin/api-management/internal/apis/${apiDetails.uuid}/assets`;
  await axios.post(url, formData, { credentials: 'include' })
    .then((response) => {
      const data = apiDetails;
      if (isUploadFile) {
        data.files = response.data;
      }
      dispatch({
        type: constants.API_SAVE_SUCCESS,
        payload: data,
      });
    })
    .catch((error) =>
      dispatch({
        type: constants.API_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const saveApi = (details, uploadedAssets) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const userContext = getUserContext(getState());
    const data = getCreateData(userContext, details);

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/`;
    await axios.post(url, data, { credentials: 'include' })
      .then((response) => {
        if (uploadedAssets && !isEmpty(uploadedAssets.files)) {
          const apiDetails = response.data;
          saveAssets(apiDetails, uploadedAssets.files, portal, dispatch, true, []);
        } else {
          dispatch({
            type: constants.API_SAVE_SUCCESS,
            payload: response.data,
          });
        }
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateApi = (apiUuid, details) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const data = getUpdateData(apiUuid, details);

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}`;
    await axios.put(url, data, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_UPDATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateApiDetails = (apiUuid, details) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const formData = getUpdateDetails(apiUuid, details);
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}`;

    await axios.put(url, formData, { credentials: 'include' })
      .then(() => {
        dispatch({
          type: constants.API_SAVE_SUCCESS,
          payload: details,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateApiDetailsWithAssets = (apiUuid, details, initialAssets, uploadedAssets,
                                 isUploadFile, filesToDelete) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const formData = getUpdateDetails(apiUuid, details);
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}`;

    await axios.put(url, formData, { credentials: 'include' })
      .then(() => {
        const apiDetails = details;
        if (isUploadFile || filesToDelete.length > 0) {
          saveAssets(apiDetails, uploadedAssets.files, portal, dispatch,
            isUploadFile, filesToDelete);
        } else {
          dispatch({
            type: constants.API_SAVE_SUCCESS,
            payload: apiDetails,
          });
        }
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const publishApi = async (apiUuid, portal, dispatch) => {
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/publish`;
  await axios.put(url, '', { credentials: 'include' })
    .then((response) =>
      dispatch({
        type: constants.API_PUBLISH_SAVE_SUCCESS,
        isLoading: false,
        payload: response,
      }),
    )
    .catch((error) =>
      dispatch({
        type: constants.API_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const fetchApiCustomFields = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/custom-fields`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_CUSTOM_FIELDS_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const saveApiCustomFields = (apiUuid, customFieldValues) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const data = map(customFieldValues, (value, key) => ({
      customFieldUuid: key,
      value,
    }));
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/custom-fields`;
    await axios.put(url, data, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_CUSTOM_FIELDS_SAVE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchApiPolicyEntities = (apiUuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/policy-entities`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.API_POLICY_TEMPLATES_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const saveApiPolicyEntities = (apiUuid, data) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/policy-entities`;
    await axios.put(url, data, { credentials: 'include' })
      .then(() => {
        publishApi(apiUuid, portal, dispatch);
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

const callSaveOrganizationsAPI = (data, apiUuid, portal, dispatch) => {
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/organizations`;
  axios.put(url, data, { credentials: 'include' })
    .then(() => {
      dispatch({
        type: constants.API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS,
      });
    })
    .catch((error) =>
      dispatch({
        type: constants.API_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

const saveManageOrgApi = (
  selectedManageOrg,
  apiDetails,
  apiUuid,
  portal,
  dispatch,
  retainManagingOrgVisibility,
) => {
  const data = getUpdateData(apiUuid, apiDetails);
  data.managingOrgUuid = selectedManageOrg ? selectedManageOrg.uuid : null;
  let url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}`;
  if (retainManagingOrgVisibility === true || retainManagingOrgVisibility === false) {
    url = `${url}?retainManagingOrgVisibility=${retainManagingOrgVisibility}`;
  }
  axios
    .put(url, data, { credentials: 'include' })
    .then(() => {
      dispatch({
        type: constants.API_PERMISSION_SAVE_SUCCESS,
        payload: data,
      });
    })
    .catch((error) =>
      dispatch({
        type: constants.API_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const savePermissions = (data, apiUuid, selectedManageOrg, isSavePermissionApi,
  isSaveManageOrgApi, retainManagingOrgVisibility) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const apiDetails = getApiDetails(getState());
    if (!isSavePermissionApi && isSaveManageOrgApi) {
      saveManageOrgApi(selectedManageOrg, apiDetails, apiUuid, portal, dispatch,
          retainManagingOrgVisibility);
    } else {
      const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/permissions/apis/${apiUuid}`;
      await axios.put(url, data, { credentials: 'include' })
        .then(() => {
          if (selectedManageOrg === null || apiDetails.managingOrgUuid !== selectedManageOrg.uuid) {
            saveManageOrgApi(selectedManageOrg, apiDetails, apiUuid, portal, dispatch);
          } else {
            dispatch({
              type: constants.API_PERMISSION_SAVE_SUCCESS,
              payload: apiDetails,
            });
          }
        })
        .catch((error) =>
          dispatch({
            type: constants.API_ERROR,
            payload: getValidationErrors(error),
          }),
        );
    }
  };

export const saveApiAccessStatus = (accessStatus, apiUuid, canSaveOrgadminDev,
  dataToSave) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const apiDetails = getApiDetails(getState());
    const data = getUpdateData(apiUuid, apiDetails);
    data.uuid = apiUuid;
    data.accessStatus = accessStatus;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}`;

    await axios.put(url, data, { credentials: 'include' })
      .then((response) => {
        if (accessStatus === constants.API_ACCESS_STATUS_PRIVATE && !canSaveOrgadminDev) {
          callSaveOrganizationsAPI(dataToSave, apiUuid, portal, dispatch);
        } else {
          dispatch({
            type: constants.API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS,
            payload: response.data,
          });
        }
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const saveTagsAssociation = (data, apiUuid) =>
  async (dispatch, getState) => {
    initApi(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/apis/${apiUuid}/tags`;
    dispatch({
      type: constants.API_TAGS_ASSOCIATE_REQUEST,
      isLoading: false,
    });
    await axios.put(url, data, { credentials: 'include' })
      .then(() => {
        dispatch({
          type: constants.API_TAGS_ASSOCIATE_SUCCESS,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.API_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };




// WEBPACK FOOTER //
// ./src/actions/api/index.js